import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import styled from "styled-components";
import Link from "next/link";
import { HeaderImageBanner } from "@components/layout/header/HeaderImageBanner";

const MegaMenuWrapper = styled.div`
  display: flex;
  width: 100%;
  background-color: #ffffff;
  border-top: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
`;

const LeftMenu = styled.div`
  width: 170px;
  background-color: #f4f4f4;
  display: flex;
  flex-direction: column;
`;

const MenuButton = styled.button`
  padding: 92px 20px;
  border: none;
  border-bottom: 1px solid white;
  background-color: #ffffff;
  color: #3bb77e;
  font-weight: 700;
  text-align: start;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 16px;
  line-height: 1.4;

  &:hover {
    background-color: #ffffff;
    color: #3bb77e;
  }
`;

const MenuSubButton = styled.button`
  padding: 26px 20px;
  border: none;
  border-bottom: 1px solid white;
  background-color: #f3f3f3;
  color: #7b7b7b;
  font-weight: 500;
  text-align: start;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 16px;
  line-height: 1.4;

  &:hover {
    background-color: #ffffff;
    color: #3bb77e;
  }
`;

const GridAndBanner = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-x: hidden; /* 스크롤 없애기 */
`;

const CategoryGrid = styled.div`
  display: flex;
`;

const CategoryImg = styled.img`
  background: #f4f4f4;
  border-radius: 16px;
  padding: 10px;
  margin-bottom: 10px;
  width: 80px;
  height: 80px;
  object-fit: contain;
  cursor: pointer;
`;

const CategoryBox = styled.div`
  flex: 0 0 auto;
  width: 128px;
  display: flex;
  flex-direction: column;
  padding: 15px 20px;
  border-right: 1px solid #e0e0e0;

  &:last-child {
    border-right: none;
  }

  /* 위아래 공간 만들기 */
  margin-top: 15px;
  margin-bottom: 15px;

  h4 {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 12px;

    a {
      color: inherit;
      text-decoration: none;

      &:hover {
        color: #3bb77e;
      }
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      margin-bottom: 6px;

      a {
        font-size: 15px;
        color: #666;
        text-decoration: none;
        letter-spacing: -0.5px;
        &:hover {
          color: #3bb77e;
        }
      }
    }
  }

  ul li a.active {
    color: #3bb77e;
  }
`;

const BottomExtraMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 20px;
  gap: 20px;
  background: #f3f3f3;

  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;

  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

const EstimateCartButton = styled.a`
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  background-color: #797979;
  padding: 4px 30px;
  border-radius: 28px;
  cursor: pointer;
  white-space: nowrap;
  margin-left: auto;
  &:hover {
    background-color: #797979;
  }
`;

const BannerArea = styled.div`
  position: relative;
`;

const BannerButton = styled.button`
  position: absolute;
  bottom: 0px;
  left: 78.4%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 370px;
  margin: 6px 0;
  height: auto;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  @media (max-width: 1200px) {
    left: 80%;
    max-width: 320px;
  }
`;

const CategoryCustomizingMenu = ({
  dummyList,
  headerMenu,
  categories,
  categoriesType,
  otherMenuItems,
}) => {
  const router = useRouter();
  const second = router.query.code;
  const [categoryType, setCategoryType] = useState("S");

  const handleCategoryType = (type) => {
    setCategoryType(type);
  };

  const normalizePath = (path) => {
    return path.split("?")[0].replace(/\/+$/, "");
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <MegaMenuWrapper>
        <LeftMenu>
          <MenuButton
            // active={
            //   categoryType === "S" &&
            //   router.pathname.includes("/customizing/customizing-products")
            // }
            categoryType={categoryType}
            onClick={() => handleCategoryType("S")}
          >
            맞춤제작 &gt;
          </MenuButton>
          {otherMenuItems && otherMenuItems.length > 0 && (
            <>
              {otherMenuItems
                .filter((item) => item.title !== "맞춤제작")
                .map((item, idx, arr) => {
                  return (
                    <MenuSubButton
                      key={idx}
                      onClick={() => {
                        router.push(item.url);
                      }}
                    >
                      {item.title}
                    </MenuSubButton>
                  );
                })}
            </>
          )}
        </LeftMenu>

        <GridAndBanner>
          <CategoryGrid>
            {categories?.map((category, idx) => (
              <CategoryBox key={idx}>
                <CategoryImg
                  src={category.image}
                  alt={category.name}
                  onClick={() =>
                    router.push(
                      `/customizing/customizing-products/new/?first=${category.code}&code=`
                    )
                  }
                />
                <h4>
                  <Link
                    href={`/customizing/customizing-products/new/?first=${category.code}&code=`}
                  >
                    <a>{category.name}</a>
                  </Link>
                </h4>
                <ul>
                  {category.children?.map((child, cIdx) => (
                    <li key={cIdx}>
                      <Link
                        href={`/customizing/customizing-products/new/?first=${category.code}&code=${child.code}`}
                      >
                        <a
                          className={second === child.code ? "active" : ""}
                          style={{
                            fontWeight: "100",
                          }}
                        >
                          {child.name}
                        </a>
                      </Link>
                    </li>
                  ))}
                </ul>
              </CategoryBox>
            ))}
          </CategoryGrid>

          {/* 오른쪽 배너 */}
          {categoryType === "S" && headerMenu?.length > 0 && (
            <BannerArea>
              <BannerButton
                onClick={() => {
                  const url =
                    (headerMenu &&
                      headerMenu.length > 0 &&
                      headerMenu[0]?.link_url) ||
                    "https://www.caretstore.co.kr/";
                  router.push(url);
                }}
              >
                {Array.isArray(headerMenu) && headerMenu[0]?.P_FileUrl ? (
                  <HeaderImageBanner
                    imageUrl={headerMenu[0].P_FileUrl}
                    altText={headerMenu[0].img_alt || "헤더 배너 이미지"}
                  />
                ) : null}
              </BannerButton>
            </BannerArea>
          )}
        </GridAndBanner>
      </MegaMenuWrapper>
      {/* 하단 메뉴 */}
      <BottomExtraMenu>
        <Link
          href="https://www.caretstore.co.kr/customizing/customizing-cart/"
          passHref
        >
          <EstimateCartButton>견적 바구니</EstimateCartButton>
        </Link>
      </BottomExtraMenu>
    </div>
  );
};

export default CategoryCustomizingMenu;
